import { connect } from 'react-redux';
import { fetchTeam, createTeam } from '../../actions/actions-index';
import TeamEdit from '../../components/Team/TeamEdit';
import { reduxForm } from "redux-form";
import * as _ from 'lodash';

function mapStateToProps(state, ownProps) {
    let initValue = null;
    if (ownProps.match.params) {
        initValue = state.team[ownProps.match.params.id];
    }
    return {
        initialValues: initValue,
        id: ownProps.match.params ? ownProps.match.params.id : '',
        enableReinitialize: true
    }
}

const validate = values => {
    const errors = {};
    if (!values.teamName || !values.teamName.trim()) {
        errors.teamName = 'Required';
    }
    if (!values.owner || !values.owner.trim()) {
        errors.owner = 'Required';
    }
    if (!_.isEmpty(errors)) {
        errors._error = 'Error while submitting. Check invalid fields above.';
    }
    return errors;
};

let TeamEditForm = reduxForm({
    // a unique name for the form
    form: 'teamForm',
    validate
})(TeamEdit);

export default connect(
    mapStateToProps,
    {
        fetchTeam,
        createTeam,
    }
)(TeamEditForm);



// WEBPACK FOOTER //
// ./src/containers/Team/TeamEditContainer.js